import React from 'react'
import Parse from 'parse'
import { makeAutoObservable } from 'mobx'
import { UserRole } from '../Models/UserRole'
import { SkaCard } from '../Models/SkaCard'
import { SkaReflections } from '../Models/SkaReflection'
import { SkaFile } from '../Models/SkaFile'
import { SkaOperationsPlanning } from '../Models/SkaOperationsPlanning'
import { SkaProjectPlanning } from '../Models/SkaProjectPlanning'
import cheerio, { load } from 'cheerio'
import { School } from '../Models/School'
import i18n from '../i18nextConfig'
import { t } from 'i18next'

export enum SkaNumbers {
  OperationsPlanning = 110,
  ProjectPlanning = 120,
  Reflections = 130,
}

/*

  ProjectPlanning -> Undervisning -> 120
  OperationsPlanning -> Utbildning -> 110
  Reflections -> Barndokumentation -> 130

*/

/*
  SKACardType: Int { case text = 10, images = 20, pdfs = 30, curriculums = 40, tags = 50, relation_verksamhetsplan = 110, relation_projektplan = 120, relation_reflektioner = 130, relation_blogg_doc = 140
*/

class ExportStore {
  skaItems: any[] = []
  skaProjectPlanning: SkaProjectPlanning[] = []
  skaOperationsPlanning: SkaOperationsPlanning[] = []
  skaReflections: SkaReflections[] = []
  title?: string
  constructor() {
    makeAutoObservable(this)
  }

  setTitle = (title: string) => {
    this.title = title
  }

  setSkaItems = (skaItems: any) => {
    this.skaItems = skaItems
  }

  /* FOR NEW EXPORT */
  exportBlogPortfolio = async (startDate: Date, endDate: Date) => {
    const kids = await Parse.Cloud.run('exportBlogPortfolio', {
      schoolId: '7FuxpelCzk',
      //objectIds: ['skPfVCZz19', 'vaYuq6lir3', 'mfIual41Bo'],
      objectIds: undefined,
      optimizeImages: true,
      includeReflections: true,
      includeCurriculums: true,
      includeTags: true,
      createPrePage: true,
      prePageTitle: 'Hejsan en fin titel!',
      pdfName: 'Ett pdf namn',
      fromDate: startDate,
      toDate: endDate,
      languageCode: 'es',
      type: 20,
      filter: {
        departmentIds: undefined,
        tagIds: undefined,
        kidIds: undefined,
        textSearch: undefined,
      },
    })
  }

  /* END */

  getSkaProjectPlanningTitle = async (id: string) => {
    const skaItemsQuery = new Parse.Query(SkaProjectPlanning)
    skaItemsQuery.equalTo('objectId', id)
    const data = await skaItemsQuery.first()
    this.setTitle(data?.name ?? '')
  }

  getSkaOperationsPlanningTitle = async (id: string) => {
    const skaItemsQuery = new Parse.Query(SkaOperationsPlanning)
    skaItemsQuery.equalTo('objectId', id)
    const data = await skaItemsQuery.first()
    this.setTitle(data?.name ?? '')
  }

  getSkaReflectionsTitle = async (id: string) => {
    const skaItemsQuery = new Parse.Query(SkaReflections)
    skaItemsQuery.equalTo('objectId', id)
    const data = await skaItemsQuery.first()
    this.setTitle(data?.name ?? '')
  }

  setSkaProjectPlanning = (skaProjectPlanning: SkaProjectPlanning[]) => {
    this.skaProjectPlanning = skaProjectPlanning
  }

  setSkaOperationsPlanning = (
    skaOperationsPlanning: SkaOperationsPlanning[],
  ) => {
    this.skaOperationsPlanning = skaOperationsPlanning
  }

  setSkaReflections = (skaReflections: SkaReflections[]) => {
    this.skaReflections = skaReflections
  }

  getSkaProjectPlannings = async (schoolId: string) => {
    const visibilityTypesToGet = [11, 12, 13]
    this.setSkaItems([])
    const skaItemsQuery = new Parse.Query(SkaProjectPlanning)
    skaItemsQuery
      .equalTo('school_pointer', School.createWithoutData(schoolId))
      .exists('publish_date')
      .addAscending('name')
      .containedIn('visibility', visibilityTypesToGet)
    const data = await skaItemsQuery.limit(10000).find()
    this.setSkaProjectPlanning(data)
  }

  getSkaOperationsPlanning = async (schoolId: string) => {
    const visibilityTypesToGet = [11, 12, 13]
    this.setSkaItems([])
    const skaItemsQuery = new Parse.Query(SkaOperationsPlanning)
    skaItemsQuery
      .equalTo('school_pointer', School.createWithoutData(schoolId))
      .exists('publish_date')
      .addAscending('name')
      .containedIn('visibility', visibilityTypesToGet)
    const data = await skaItemsQuery.limit(10000).find()
    this.setSkaOperationsPlanning(data)
  }

  getSkaReflections = async (schoolId: string) => {
    const visibilityTypesToGet = [11, 12, 13]
    this.setSkaItems([])
    const skaItemsQuery = new Parse.Query(SkaReflections)
    skaItemsQuery
      .equalTo('school_pointer', School.createWithoutData(schoolId))
      .exists('publish_date')
      .addAscending('name')
      .containedIn('visibility', visibilityTypesToGet)
    const data = await skaItemsQuery.limit(10000).find()
    this.setSkaReflections(data)
  }

  getSkaProjectItems = async (id: string) => {
    const skaItemsQuery = new Parse.Query(SkaProjectPlanning)
    skaItemsQuery.equalTo('objectId', id)
    const data = await skaItemsQuery.first()
    const items: any = await this.getCardItems(id, SkaNumbers.ProjectPlanning)

    items?.forEach((item: any) => {
      this.skaItems.push(item)
    })

    this.setSkaItems(this.skaItems)
    //console.log('cards', cards)
  }

  getSkaOperationItems = async (id: string) => {
    const skaItemsQuery = new Parse.Query(SkaOperationsPlanning)
    skaItemsQuery.equalTo('objectId', id)
    const data = await skaItemsQuery.first()
    const items: any = await this.getCardItems(
      id,
      SkaNumbers.OperationsPlanning,
    )
    if (items && items.length) {
      items?.forEach((item: any) => {
        this.skaItems.push(item)
      })

      //this.setSkaItems(this.skaItems)
    }
    //console.log('cards', cards)
  }

  getSkaReflectionItems = async (id: string) => {
    const skaItemsQuery = new Parse.Query(SkaReflections)
    skaItemsQuery.equalTo('objectId', id)
    const data = await skaItemsQuery.first()
    const items: any = await this.getCardItems(id, SkaNumbers.Reflections)
    items?.forEach((item: any) => {
      this.skaItems.push(item)
    })

    this.setSkaItems(this.skaItems)
    //console.log('cards', cards)
  }

  toDataUrl = (url: any, callback: any) => {
    var xhr = new XMLHttpRequest()
    xhr.onload = function () {
      var reader = new FileReader()
      reader.onloadend = function () {
        callback(reader.result)
      }
      reader.readAsDataURL(xhr.response)
    }
    xhr.open('GET', url)
    xhr.responseType = 'blob'
    xhr.send()
  }

  getSubHeader = (type: number, card: SkaCard) => {
    if (type === SkaNumbers.OperationsPlanning) {
      //return t('documentation.operation')
      return null
    } else if (type === SkaNumbers.ProjectPlanning) {
      //return t('documentation.project')
      return null
    } else if (type === SkaNumbers.ProjectPlanning) {
      //return t('export.kidDocument')
      return null
    } else {
      return null
    }
  }

  getCurrContent = (curr: any) => {
    if (i18n.language === 'sv') {
      return curr.attributes.content
    } else if (i18n.language === 'en') {
      if (curr.attributes.en_content) {
        return curr.attributes.en_content
      } else {
        return curr.attributes.content
      }
    } else if (i18n.language === 'es') {
      if (curr.attributes.es_content) {
        return curr.attributes.es_content
      } else {
        return curr.attributes.content
      }
    } else {
      return curr.attributes.content
    }
  }

  replaceEmojisWithImages = (text: string) => {
    // Define a map of emoji characters and their corresponding Base64-encoded images
    const emojiMap = {
      '😁': 'data:image/png;base64,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',
      '😆': 'data:image/png;base64,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',
      // Add more emoji-image mappings as needed
    }

    // Iterate over each emoji in the emojiMap
    for (const emoji in emojiMap) {
      if (emojiMap.hasOwnProperty(emoji)) {
        // @ts-ignore
        const imageTag = `<img src="${emojiMap[emoji]}" style="height: 11px" alt="${emoji}" />`
        const regex = new RegExp(this.escapeRegExp(emoji), 'g')
        text = text.replace(regex, imageTag)
        //text = text.replace(regex, '')
      }
    }

    return text
  }

  removeEmojis = (text: string) => {
    // Regular expression to match emojis
    const emojiRegex =
      /[\uD800-\uDBFF][\uDC00-\uDFFF]|\u203C\uFE0F|\u2049\uFE0F|\u20E3|\u00A9\uFE0F|\u00AE\uFE0F|\u2122\uFE0F|\uD83C[\uDC04\uDCCF\uDD70-\uDD71\uDD7E-\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01-\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50-\uDE51\uDE5C-\uDE5E\uDE80-\uDE83\uDE85-\uDE8B\uDE9A-\uDE9F\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEAD\uDEB0\uDEB2-\uDEB5\uDEB7-\uDEB8\uDEBA\uDEBC-\uDEBE\uDEC0-\uDEC3\uDEC5\uDEC6-\uDECA\uDECC-\uDED2\uDED5-\uDED6\uDED9\uDEDB-\uDEDD\uDEE0-\uDEE5\uDEE9-\uDEED\uDEEF-\uDEF3\uDEF5-\uDEF7\uDEF9-\uDEFC\uDF00-\uDF01\uDF0A-\uDF21\uDF24-\uDF93\uDF96-\uDF97\uDF99-\uDF9B\uDF9E-\uDF9F\uDFA3\uDFA6-\uDFA8\uDFAE-\uDFAF\uDFB1-\uDFB2\uDFB4-\uDFB5\uDFB7-\uDFBA\uDFBC-\uDFCB\uDFCE-\uDFD4\uDFD7-\uDFDF\uDFE2\uDFE3\uDFE7\uDFE9-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDD00-\uDDFF\uDE00-\uDE4F\uDE80-\uDEFF\uDF00-\uDFFF]|\uD83E[\uDD00-\uDDFF\uDE10-\uDE11\uDE30-\uDE44\uDE50-\uDEFF]/g

    // Replace emojis with an empty string
    const result = text.replace(emojiRegex, '')

    return result
  }

  // Helper function to escape special characters in a regular expression
  escapeRegExp = (string: string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  }

  getCurrTag = (curr: any) => {
    if (i18n.language === 'sv') {
      if (curr.attributes.tags) {
        return {
          title:
            curr.attributes.tags && curr.attributes.tags.length
              ? curr.attributes.tags[0]
              : curr.attributes.category,
          tagColor:
            curr.attributes.tags_color && curr.attributes.tags_color.length
              ? curr.attributes.tags_color[0]
              : '#80B6F5',
        }
      } else {
        return {
          title: curr.attributes.category,
          tagColor:
            curr.attributes.tags_color && curr.attributes.tags_color.length
              ? curr.attributes.tags_color[0]
              : '#80B6F5',
        }
      }
    } else if (i18n.language === 'en') {
      if (curr.attributes.en_tags) {
        return {
          title:
            curr.attributes.en_tags && curr.attributes.en_tags.length
              ? curr.attributes.en_tags[0]
              : curr.attributes.category,
          tagColor:
            curr.attributes.tags_color && curr.attributes.tags_color.length
              ? curr.attributes.tags_color[0]
              : '#80B6F5',
        }
      } else {
        return {
          title: curr.attributes.category,
          tagColor:
            curr.attributes.tags_color && curr.attributes.tags_color.length
              ? curr.attributes.tags_color[0]
              : '#80B6F5',
        }
      }
    } else if (i18n.language === 'es') {
      if (curr.attributes.es_tags) {
        return {
          title:
            curr.attributes.es_tags && curr.attributes.es_tags.length
              ? curr.attributes.es_tags[0]
              : curr.attributes.category,
          tagColor:
            curr.attributes.tags_color && curr.attributes.tags_color.length
              ? curr.attributes.tags_color[0]
              : '#80B6F5',
        }
      } else {
        return {
          title: curr.attributes.category,
          tagColor:
            curr.attributes.tags_color && curr.attributes.tags_color.length
              ? curr.attributes.tags_color[0]
              : '#80B6F5',
        }
      }
    } else {
      return {
        title:
          curr.attributes.tags && curr.attributes.tags.length
            ? curr.attributes.tags[0]
            : curr.attributes.category,
        tagColor:
          curr.attributes.tags_color && curr.attributes.tags_color.length
            ? curr.attributes.tags_color[0]
            : '#80B6F5',
      }
    }
  }

  getCardItems = async (id: string, type: number) => {
    const skaItemsQuery = new Parse.Query(
      type === SkaNumbers.Reflections
        ? SkaReflections
        : type === SkaNumbers.ProjectPlanning
        ? SkaProjectPlanning
        : SkaOperationsPlanning,
    )
    skaItemsQuery.equalTo('objectId', id)

    const data = await skaItemsQuery.first()
    if (data) {
      const cardIds: any = []
      data.attributes.cards?.forEach((card: any) => {
        cardIds.push(card)
      })

      if (cardIds.length) {
        const cardsQuery = new Parse.Query(SkaCard)
        //cardsQuery.addDescending('createdAt')
        cardsQuery.containedIn('objectId', cardIds)
        cardsQuery.include('images')
        cardsQuery.include('pdfs')
        cardsQuery.include('curriculums')
        cardsQuery.include('relation_to')
        cardsQuery.include('relation_to.doc_tags')
        cardsQuery.include('relation_to.images')
        cardsQuery.include('relation_to.curriculums')
        cardsQuery.include('relation_to.ska_project_planning')

        const cards = await cardsQuery.limit(10000).find()
        const items: any[] = []
        let index = 0
        for (const card of cards.sort((a, b) => {
          const indexA = cardIds.indexOf(a.id)
          const indexB = cardIds.indexOf(b.id)
          return indexA - indexB
        })) {
          if (card.attributes.card_type === 20) {
            // Bilder
            items.push({
              id: Math.random().toString().replace('0.', ''),
              content: t('general.pictures'),
              type: 'header',
              available: true,
              subHeader: this.getSubHeader(type, card),
            })

            for (const image of card.attributes.images) {
              const tjo = await new Promise((resolve, reject) => {
                this.toDataUrl(image.attributes.image._url, (myBase64: any) => {
                  resolve(myBase64)
                })
              })

              items.push({
                id: image.id,
                content: tjo,
                type: 'image',
                available: true,
              })
            }
          }
          if (card.attributes.card_type === 30) {
            // PDF
            items.push({
              id: Math.random().toString().replace('0.', ''),
              content: 'PDF',
              type: 'header',
              available: true,
              subHeader: this.getSubHeader(type, card),
            })

            for (const pdf of card.attributes.pdfs) {
              /*const tjo = await new Promise((resolve, reject) => {
                this.toDataUrl(image.attributes.image._url, (myBase64: any) => {
                  resolve(myBase64)
                })
              })*/

              items.push({
                id: pdf.id,
                content: pdf.attributes.pdf._url,
                type: 'pdf',
                available: true,
              })
            }
          }
          if (card.attributes.card_type === 10) {
            // Fritext
            items.push({
              id: Math.random().toString().replace('0.', ''),
              content: t('export.freeText'),
              type: 'header',
              available: true,
            })
            items.push({
              id: card.id,
              /*content: card.text
                .replaceAll('<font size="4"', '<p style="font-size: 11px"')
                .replaceAll('<font size="5"', '<p style="font-size: 13px"'),*/
              content: this.replaceFontTags(card.text)
                .replaceAll('font-size: large;', 'font-size: 10px;')
                .replaceAll('pt;', 'px;'),
              //content: card.text,
              type: 'text',
              available: true,
            })
          }
          if (card.attributes.card_type === 40) {
            // Curriculums
            items.push({
              id: Math.random().toString().replace('0.', ''),
              content: 'Curriculums',
              type: 'header',
              available: true,
              subHeader: this.getSubHeader(type, card),
            })

            card.attributes.curriculums?.forEach((curr: any) => {
              items.push({
                id: curr.id,
                content: this.getCurrContent(curr),
                tag: this.getCurrTag(curr),
                type: 'curriculums',
                available: true,
              })
            })
          }
          if (card.attributes.card_type === 50) {
            // Taggar
            // Depricated .. ?
          }
          if (card.attributes.card_type === 140) {
            // Blogg
            items.push({
              id: Math.random().toString().replace('0.', ''),
              content: t('menu.blog'),
              type: 'header',
              available: true,
              subHeader: this.getSubHeader(type, card),
            })

            for (const blog of card.attributes.relation_to) {
              items.push({
                id: blog.id,
                content: blog.attributes.content,
                type: 'text',
                available: true,
              })

              if (blog.attributes.doc_tags) {
                for (const tag of blog.attributes.doc_tags) {
                  items.push({
                    id: tag.id,
                    content: tag.attributes.name,
                    type: 'tag',
                    bgColor: tag.attributes.bg_color,
                    available: true,
                  })
                }
              }

              if (blog.attributes.curriculums) {
                for (const curr of blog.attributes.curriculums) {
                  items.push({
                    id: curr.id,
                    content: this.getCurrContent(curr),
                    tag: this.getCurrTag(curr),
                    type: 'curriculums',
                    available: true,
                  })
                }
              }

              if (blog.attributes.images && blog.attributes.images.length) {
                for (const image of blog.attributes.images) {
                  const tjo = await new Promise((resolve, reject) => {
                    this.toDataUrl(
                      image.attributes.image._url,
                      (myBase64: any) => {
                        resolve(myBase64)
                      },
                    )
                  })
                  items.push({
                    id: image.id,
                    content: tjo,
                    type: 'image',
                    available: true,
                  })
                }
              }
            }
          }
          /*
          TODO: 120
          */
          //if (card.attributes.card_type === 130) {
          if (card.attributes.card_type === SkaNumbers.ProjectPlanning) {
            for (var i = 0; i < card.attributes.relation_to.length; i++) {
              await this.getSkaProjectItems(card.attributes.relation_to[i].id)
            }

            //card.attributes.relation_to.forEach((rel) => )
          }

          //if (card.attributes.card_type === 120) {
          if (card.attributes.card_type === SkaNumbers.Reflections) {
            //console.log('id', card.attributes.relation_to.attributes.id)
            for (var i = 0; i < card.attributes.relation_to.length; i++) {
              this.getSkaReflectionItems(card.attributes.relation_to[i].id)
            }
            //card.attributes.relation_to.forEach((rel) => )
          }

          //if (card.attributes.card_type === 110) {
          if (card.attributes.card_type === SkaNumbers.OperationsPlanning) {
            //console.log('id', card.attributes.relation_to.attributes.id)
            for (var i = 0; i < card.attributes.relation_to.length; i++) {
              this.getSkaOperationItems(card.attributes.relation_to[i].id)
            }
            //card.attributes.relation_to.forEach((rel) => )
          }

          if (card.attributes.card_type === 130) {
          } else if (card.attributes.card_type === 120) {
          } else if (card.attributes.card_type === 110) {
          } else {
            items.push({
              id: index,
              content: '',
              type: 'line',
            })
          }

          index++
        }
        return items
      }
    }
  }

  /*replaceFontTags(input: string): string {
    let replacedString = input
    let fontTagRegex = /<font\b([^>]*)>(.*?)<\/font>/gi

    while (fontTagRegex.test(replacedString)) {
      replacedString = replacedString.replace(
        fontTagRegex,
        (match, attributes, content) => {
          let style = ''
          if (attributes) {
            const attributesRegex = /(\w+)=['"](.*?)['"]/gi
            let match
            while ((match = attributesRegex.exec(attributes))) {
              const [, attributeName, attributeValue] = match
              if (attributeName === 'color') {
                style += `color:${attributeValue};`
              } else if (attributeName === 'size') {
                let fontSize: string
                switch (attributeValue) {
                  case '4':
                    fontSize = '12px'
                    break
                  case '5':
                    fontSize = '14px'
                    break
                  default:
                    fontSize = 'inherit'
                    break
                }
                style += `font-size:${fontSize};`
              }
            }
          }

          return `<p style='${style}'>${content}</p>`
        },
      )
    }

    return replacedString
  }*/

  replaceFontTags(input: string): string {
    const $ = load(input)

    $('font').each((index, element) => {
      const $font = $(element)
      const color = $font.attr('color')
      const size = $font.attr('size')
      const content: any = $font.html()

      let style = ''
      if (color) {
        style += `color:${color};`
      }
      if (size) {
        let fontSize: string
        switch (size) {
          case '3':
            fontSize = '8px'
            break
          case '4':
            fontSize = '10px'
            break
          case '5':
            fontSize = '12px'
            break
          case '6':
            fontSize = '14px'
            break
          default:
            fontSize = 'inherit'
            break
        }
        style += `font-size:${fontSize};`
      }

      const $p = $('<p>').attr('style', style).html(content)
      $font.replaceWith($p)
    })

    $('li').each((index, element) => {
      const $font = $(element)
      const color = $font.attr('color')
      const size = $font.attr('size')
      const content: any = $font.html()

      let style = ''
      if (color) {
        style += `color:${color};`
      }
      if (size) {
        let fontSize: string
        switch (size) {
          case '4':
            fontSize = '10px'
            break
          case '5':
            fontSize = '12px'
            break
          default:
            fontSize = 'inherit'
            break
        }
        style += `font-size:${fontSize};`
      }

      const $p = $('<p>').attr('style', style).html(content)
      $font.replaceWith($p)
    })

    return $.html()
  }
}
export const exportStore = (() => {
  return new ExportStore()
})()
export const ExportStoreContext: React.Context<ExportStore> =
  React.createContext(exportStore)
